import { designTokens } from "@cinch-labs/design-system";
var isTouchAvailable = function() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
};
export function isMobile() {
    return window && window.matchMedia && !window.matchMedia(designTokens.customMedia.s).matches && isTouchAvailable();
}
